import React from 'react';

import { useIntl } from 'react-intl';

import scorecardIllustrationUrl from '../assets/scorecard-illustration.svg';
import { StateMessage } from '../state-message';

import messages from './messages';

export const EmptyState = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<StateMessage
			illustrationUrl={scorecardIllustrationUrl}
			title={intl.formatMessage(messages.emptyStateTitle)}
			subtitle={intl.formatMessage(messages.emptyStateSubtitle)}
			testId="rovo-for-you-empty-state"
		/>
	);
};
